import { render, staticRenderFns } from "./KpiSegmentForm.vue?vue&type=template&id=519af5df"
import script from "./KpiSegmentForm.vue?vue&type=script&lang=js"
export * from "./KpiSegmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports